import { Injectable } from '@angular/core';
import { NavigationHelper } from '@core/services/core/navigation-helper.service';
import {
  NonRenewalContextState, NRConfig, PolicyConf, ReasonConf
} from '@models/non-renewal';
import { Policy } from '@models/policy';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NonRenewalContextService {
  private state$: Subject<Partial<NonRenewalContextState>>;
  private mmobileConfig: NRConfig;
  private policyTarget: Policy;
  private policyConf: PolicyConf;
  private policyReasons: ReasonConf[];

  constructor(private nav: NavigationHelper) {}

  setPolicyTarget(policy) {
    this.policyTarget = policy;
  }

  setState(state: Partial<NonRenewalContextState> = {}) {
    if (!this.state$ || this.state$.isStopped)
      this.state$ = new BehaviorSubject<Partial<NonRenewalContextState>>(state);
  }

  getState() {
    if (!this.state$ || this.state$.isStopped) {
      this.setState();
    }
    return this.state$.asObservable();
  }

  updateState(state: Partial<NonRenewalContextState>) {
    if (!this.state$) {
      this.setState();
    }
    this.state$.next(state);
  }

  completeState() {
    if (this.state$) this.state$.complete();
  }

  clear() {
    this.completeState();
  }

  get policy(): Policy {
    if (!this.policyTarget) {
      this.completeState();
      this.nav.back('client-area/home');
    }
    return this.policyTarget;
  }

  set reasons(reasons: ReasonConf[]) {
    this.policyReasons = reasons;
  }

  get reasons(): ReasonConf[] {
    return this.policyReasons;
  }

  get policyConfig(): PolicyConf {
    return this.policyConf;
  }

  set policyConfig(policyConf: PolicyConf) {
    this.policyConf = policyConf;
  }

  set config(config: NRConfig) {
    this.mmobileConfig = config;
  }

  get config(): NRConfig {
    return this.mmobileConfig;
  }
}
